import apiClient from '../api/apiClient';

const UTILITY_CDSL = '/api/v1/utility/credit-and-closing-balance/extraction';
const ADMIN_MATCH = '/api/v1/admin/real-inventory/cdsl/match';
const ADMIN_BULK_ADD = '/api/v1/admin/real-inventory/cdsl/bulk-add';

const OCR_TIMEOUT_MS = 900000;

const multipartConfig = {
  timeout: OCR_TIMEOUT_MS,
  headers: {
    'Content-Type': false,
  },
};

const unwrap = (response) => response.data?.data ?? response.data;

export async function extractCdslStatement(file) {
  const formData = new FormData();
  formData.append('file', file);

  const response = await apiClient.request({
    method: 'POST',
    url: UTILITY_CDSL,
    data: formData,
    ...multipartConfig,
  });

  return response.data;
}

export async function matchCdslCredits(extractions) {
  const response = await apiClient.post(ADMIN_MATCH, { extractions });
  return unwrap(response);
}

export async function bulkAddRealLots(lots) {
  const response = await apiClient.post(ADMIN_BULK_ADD, { lots });
  return unwrap(response);
}

export default {
  extractCdslStatement,
  matchCdslCredits,
  bulkAddRealLots,
};
